import apiFetch from '../apiFetch'

export default function (token, extraSaleId) {
  return apiFetch({ endPoint: `ExtraSaleType/${extraSaleId}/Recover`, method: 'PUT', extraSaleTypeId: null, token: token })
}
